<template>
  <div>
    <v-btn
      v-if="!isIncludedInCart"
      color="primary"
      :small="isSmall"
      :class="htmlClass"
      :loading="submitting"
      @click="addPictureToCart(picture)"
    >
      <v-icon :small="isSmall">shopping_cart</v-icon>
      に入れる
    </v-btn>
    <v-btn
      v-else
      dark
      color="negative"
      :small="isSmall"
      :class="htmlClass"
      :loading="submitting"
      @click="removePictureFromCart(picture)"
    >
      <v-icon :small="isSmall">shopping_cart</v-icon>
      から外す
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import ApiErrorHandler from "../../../../mixins/ApiErrorHandler";

import Picture from "../../../../models/Picture";

// TODO: componentsでは直接storeを変更しないようにしたい。どこでstoreを変更しているかわからなくなりそう。
export default {
  mixins: [ApiErrorHandler],
  props: {
    organizationId: {
      type: Number,
      required: true
    },
    salesManagementId: {
      type: Number,
      required: true
    },
    picture: {
      type: Picture,
      required: true
    },
    htmlClass: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false
    };
  },
  computed: {
    ...mapState({
      apiClient: "apiClient"
    }),
    ...mapGetters({
      cartPictureIds: "cart/pictureIds"
    }),
    isSmall() {
      return !!this.small;
    },
    isIncludedInCart() {
      return this.cartPictureIds.has(this.picture.id);
    }
  },
  methods: {
    async addPictureToCart(picture) {
      this.submitting = true;
      try {
        await this.$store.dispatch("cart/addPictureToCart", {
          pictureId: picture.id,
          count: 1
        });
      } catch (errors) {
        if (this.isGlobalApiErrors(errors)) {
          this.handleApiErrors(errors, {
            store: this.$store,
            router: this.$router,
            sentry: this.sentry
          });
        } else {
          this.$store.dispatch("openErrorDialog", {
            messages: errors.getErrorMessages()
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    async removePictureFromCart(picture) {
      this.submitting = true;
      try {
        await this.$store.dispatch("cart/removePictureFromCart", {
          pictureId: picture.id
        });
      } catch (errors) {
        if (this.isGlobalApiErrors(errors)) {
          this.handleApiErrors(errors, {
            store: this.$store,
            router: this.$router,
            sentry: this.sentry
          });
        } else {
          this.$store.dispatch("openErrorDialog", {
            messages: errors.getErrorMessages()
          });
        }
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
